import React, { useCallback } from "react";
import { ProductTipBanner } from "@design-system/Banner/ProductTipBanner";
import { Button } from "@design-system/Button/Button";
import { HELP_CENTER_URLS, useHelpCenterUrl } from "@hooks/useHelpCenterUrl";
import { CloseIcon } from "@icons";
import { HStack } from "@design-system/HStack/HStack";

interface RulesProductTipBannerProps {
    onDismiss: () => void;
}

export const RulesProductTipBanner: React.FC<RulesProductTipBannerProps> = ({
    onDismiss,
}) => {
    const readMoreUrl = useHelpCenterUrl(HELP_CENTER_URLS.rules);

    const handleReadMore = useCallback(() => {
        if (!readMoreUrl) {
            return;
        }

        window.open(readMoreUrl, "_blank", "noopener,noreferrer");
    }, [readMoreUrl]);

    return (
        <ProductTipBanner
            title="Let AI and automation do the work"
            subtitle="Rules put your bookkeeping on autopilot. Kick's AI Agent learns from your actions, and you can set up rules for complex multi-condition and multi-action workflows."
            cta={
                <HStack gap={12}>
                    <Button
                        variant="primary"
                        size="md"
                        onClick={handleReadMore}
                        disabled={!readMoreUrl}
                    >
                        Read more
                    </Button>
                    <Button
                        variant="secondary"
                        size="md"
                        iconOnly
                        onClick={onDismiss}
                        aria-label="Dismiss"
                    >
                        <CloseIcon />
                    </Button>
                </HStack>
            }
        />
    );
};
